<div *ngIf="neType">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>category</mat-icon>
      {{
        neType.id ? "NE Type - " + neType.name : "Create new NE Type"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid || !neType.companyId"
      >
        <mat-icon>{{ neType.id ? "save" : "add" }}</mat-icon>
        {{ neType.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="neType.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">NE Type Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="neType.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="neType.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="neType.description"
                required
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="neType.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="neType.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
